import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldTypeConfig, FieldType } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: "formly-field-separator",
    templateUrl: "./separator.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldSeparator extends FieldType<FieldTypeConfig> {
}
